import { NumberValue } from 'd3';
import * as d3 from 'd3';

export class NormalizerAux {

    /**
     * Cria normalizador para seleção de cores com base nos valores de chuvas das vias.
     * Chamado por: processResponse
     * 
     * @param middle_data array das vias do 10-percentil até o 90-percentil
     * @return normalizador gerado com base nas vias do 10-percentil até 90-percentil
     */
    static createNormalizer(middle_data: any[], 
        funcao: (datum: any, index: number, array: Iterable<any>) => number) {

        let extent = d3.extent<number, number>(
            middle_data, funcao
        ) as Iterable<NumberValue>;

        let normalizer = d3.scaleLinear().domain(extent).range([0,1]);

        return normalizer;
    }
}